import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";

export const fetchSessionExercises = (
  sessionId: string,
  setExercises: Function,
  setLoading: Function,
  language: string
) => {
  setLoading(true);
  ApiService.get(`ephemeral-evaluations/sessions/${sessionId}/exercises`)
    .then((response) => setExercises(response.data.ephemeral_session_exercises))
    .catch((error) => {
      console.error("Error fetching session exercises:", error);
      alert(translate(language, "PAGES.EPHEMERAL_SESSION.EXERCISES_ERROR"));
    })
    .finally(() => setLoading(false));
};
